import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import zulaimage from '../../assets/product/zulaimage.png';
import { Box, IconButton } from "@mui/material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const ImageSlider = ({ images }) => {
    const swiperRef = useRef(null);
    const [activeImage, setActiveImage] = useState(images[0]?.url);

    return (
        <>
            {/* Display the currently active image */}
            <Box
                component="img"
                src={activeImage}
                alt="Centered Image"
                className="w-100 mb-3"
                sx={{
                    display: 'block',
                    width: '100%',
                    margin: '0 auto',
                    minHeight: '350px !important' // Center the image
                }}
            />

            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                {/* Previous Button */}
                <IconButton
                    data-aos="fade-right"
                    onClick={() => swiperRef.current?.slidePrev()}
                    sx={{ color: '#000' }}
                >
                    <ArrowBackIosIcon />
                </IconButton>

                {/* Swiper Slider */}
                <Swiper
                    modules={[Navigation]}
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    onSlideChange={(swiper) =>
                        setActiveImage(images[swiper.realIndex]?.url || images[0]?.url) // Handle undefined image
                    }
                    spaceBetween={20}
                    breakpoints={{
                        0: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                    }}
                    slidesPerView={3}
                    centeredSlides={true} // Center the active slide
                    loop={true}
                    style={{ width: "100%", height: "auto" }}
                >
                    {images?.map((image, index) => (
                        <SwiperSlide key={index}>
                            <img
                                src={image?.url}
                                alt={`Slide ${index + 1}`}
                                style={{ width: "100%", minHeight: '130px' }}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Next Button */}
                <IconButton
                    data-aos="fade-left"
                    onClick={() => swiperRef.current?.slideNext()}
                    sx={{ color: '#000' }}
                >
                    <ArrowForwardIosIcon />
                </IconButton>
            </Box>
        </>
    );
};

export default ImageSlider;